import React from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import LanguageSwitcher from "@iso/containers/LanguageSwitcher/LanguageSwitcher";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import { router } from "../../routes";
import { StartCapture } from "../../components/StartCapture";

export default function Topbar({ toggleSidebar }) {
  const { Logout, signed } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    Logout();
    navigate("/");
  };

  return (
    <nav className="fixed top-0 z-[46] w-full bg-white border-b shadow-sm border-gray-200">
      <div className="px-3 py-3 lg:px-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <button
              data-drawer-target="logo-sidebar"
              data-drawer-toggle="logo-sidebar"
              aria-controls="logo-sidebar"
              type="button"
              onClick={toggleSidebar}
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                ></path>
              </svg>
            </button>
          </div>
          <div className="flex items-center">
            <div className="flex items-center ml-3">
              <ul className="flex gap-y-5 items-center p-0 rounded-lg flex-row space-x-10 mt-0 border-0 bg-white">
                {signed && (
                  <StartCapture />
                )}
                <LanguageSwitcher />
                {signed && (
                  <span
                    className="hidden sm:block cursor-pointer"
                    onClick={() => handleLogout()}
                  >
                    <IntlMessages id="topbar.logout" />
                  </span>
                )}
                {!signed && (
                  <Button
                    className="rounded-full bg-primary px-6 text-white shadow-none items-center text-center"
                    onClick={() => router.navigate("/login")}
                    type="primary"
                  >
                    <FormattedMessage id="topbar.signIn" />
                  </Button>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
